import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  const [ref, setRef] = useState(1);
  const [progressPercentage, setProgressPercentage] = useState(2);
  const [showError, setShowError] = useState(false);
  const [questions, setQuestions] = useState([
    {
      id: 1,
      question: "I have a bond with my local community",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 2,
      // question: "Easy understanding of my natural talents and giftings",
      question: "I have an easy understanding of my natural talents",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 3,
      question: "I love what I do",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 4,
      question: "I have a good understanding of my flaws",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 5,
      // question: "I understand why I am here",
      question: "I recognize my place in society",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 6,
      question: "I have many long-term relationships",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 7,
      question: "I understand why I am here",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 8,
      question: "I feel full of life",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 9,
      question: "I can connect what I do with my purpose in life",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 10,
      question: "My vision is more significant than myself",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 11,
      // question: "I write down my purpose and vision for the future",
      question: "I have a good articulation of my future plans",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 12,
      question: "I have carried out pioneering projects",
      category: "Master Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    // {
    //   id: 13,
    //   question: "I have completed milestone projects",
    //   category: "Master Actualizer",
    //   options: [
    //     { id: 1, op: "Yes", isSelected: false, score: 1 },
    //     { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
    //     { id: 3, op: "No", isSelected: false, score: 0 },
    //   ],
    // },
    //second
    {
      id: 14,
      question:
        "I feel connected to my job but would love to do something else",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 15,
      // question: "I understand my character type",
      question: "I understand my habits and characteristics",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 16,
      question: "I feel like I make a difference in my community.",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 17,
      question:
        "I am effective in my work but have a tough time connecting with the people around me",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 18,
      // question: "I get easily frustrated with others",
      question: "I find myself being easily irritated by people these days",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 19,
      question: "I often follow through on what I decide to do",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 20,
      // question: "I feel like I am self-made ",
      question: "I know that I am a self-made individual",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 21,
      question: "I stay in my lane and do to examine the entire system",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 22,
      question:
        "I am actively working on finding out what I am supposed to do in life",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 23,
      question:
        "I am helpful, but it is challenging to get joy from what I do.",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 24,
      question: "I delay but eventually follow through on what I decide to do",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 25,
      question:
        "I am not there yet, but I am able to see the light at the end of this tunnel",
      category: "Transitional Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    // {
    //   id: 26,
    //   question: "I feel like I am self-made",
    //   category: "Transitional Actualizer",
    //   options: [
    //     { id: 1, op: "Yes", isSelected: false, score: 1 },
    //     { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
    //     { id: 3, op: "No", isSelected: false, score: 0 },
    //   ],
    // },
    //third
    {
      id: 27,
      question: "There is a sense of meaninglessness in day to day",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },

    {
      id: 28,
      question: "I have a lack of fulfillment in life",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 29,
      question: "I easily procrastinate",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 30,
      question: "I often wish things turned out different",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 31,
      question: "I am unable to connect with my surroundings",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 32,
      question: "I often ignore matters that are too difficult",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 33,
      question:
        "There are too many bills and issue to focus on vision and purpose",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 34,
      question: "I feel anxious when I think of the future",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 35,
      question: "I no longer know why I go to work",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 36,
      question: "I just focused on getting by day to day ",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 37,
      question: "Retirement would feel good right about now",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    {
      id: 38,
      question: "I am not actively working on future vision plans",
      category: "Emerging Actualizer",
      options: [
        { id: 1, op: "Yes", isSelected: false, score: 1 },
        { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
        { id: 3, op: "No", isSelected: false, score: 0 },
      ],
    },
    // {
    //   id: 39,
    //   question: "I am not good at future vision planning",
    //   category: "Emerging Actualizer",
    //   options: [
    //     { id: 1, op: "Yes", isSelected: false, score: 1 },
    //     { id: 2, op: "SomeWhat", isSelected: false, score: 0.5 },
    //     { id: 3, op: "No", isSelected: false, score: 0 },
    //   ],
    // },
  ]);
  const [count, setCount] = useState(0);
  const inputElement = useRef("1");
  function nextHandler() {
    // console.log(
    //   "idxcheck",
    //   questions[count].options.findIndex((v) => v.isSelected === true),
    //   questions[count].options
    // );
    if (
      questions[count].options.findIndex((v) => v.isSelected === true) !== -1
    ) {
      setShowError(false);
      if (count < questions.length - 1) {
        setCount(count + 1);
      }
    } else setShowError(true);
  }
  const handleClick = (op, topG) => {
    console.log(op, topG);
    setShowError(false);
    console.log(topG.options.findIndex((val) => val.id == op.id));
    let idx = topG.options.findIndex((val) => val.id == op.id);
    questions[count].options.forEach((op) => (op.isSelected = false));
    questions[count].options[idx].isSelected = true;
    console.log("category", topG.category, op.score);
    // op.isSelected = true;

    // console.log(e.currentTarget.textContent);
    // console.log(e.currentTarget);
    // if (e.currentTarget.textContent == "No") {
    //   console.log("BIG NO");
    // } else if (e.currentTarget.textContent == "Yes") {
    //   console.log("BIG YES");
    // } else {
    //   console.log("BIG SW");
    // }
    if (count < questions.length - 1) {
      setCount(count + 1);
      setProgressPercentage(progressPercentage + 2.4);
    } else {
      navigate("/form");
      console.log("elseeeeeeeee");
      let filteredFirst = questions.filter(
        (val) => val.category === "Master Actualizer"
      );
      let filteredSecond = questions.filter(
        (val) => val.category === "Master Actualizer"
      );
      let filteredThird = questions.filter(
        (val) => val.category === "Emerging Actualizer"
      );
      //   let filteredFourth = questions.filter(
      //     (val) => val.category === "Explorer"
      //   );
      //   let reduced = filteredFirst.filter(
      //     (val) => val.options.findIndex((itm) => itm.isSelected === true) !== -1);
      //.reduce((total = 0, curr) => total + curr.score);
      //   let reduced = filteredFirst.filter((op) =>
      //     op.options.find((v) => v.isSelected === true)
      //   );
      let score1 = 0;
      let score2 = 0;
      let score3 = 0;
      //   let score4 = 0;
      for (let i = 0; i < filteredFirst.length; i++) {
        for (let j = 0; j < filteredFirst[i].options.length; j++) {
          if (filteredFirst[i].options[j].isSelected) {
            score1 = score1 + filteredFirst[i].options[j].score;
          }
        }
      }
      for (let i = 0; i < filteredSecond.length; i++) {
        for (let j = 0; j < filteredSecond[i].options.length; j++) {
          if (filteredSecond[i].options[j].isSelected) {
            score2 = score2 + filteredSecond[i].options[j].score;
          }
        }
      }
      for (let i = 0; i < filteredThird.length; i++) {
        for (let j = 0; j < filteredThird[i].options.length; j++) {
          if (filteredThird[i].options[j].isSelected) {
            score3 = score3 + filteredThird[i].options[j].score;
          }
        }
      }
      //   for (let i = 0; i < filteredFourth.length; i++) {
      //     for (let j = 0; j < filteredFourth[i].options.length; j++) {
      //       if (filteredFourth[i].options[j].isSelected) {
      //         score4 = score4 + filteredFourth[i].options[j].score;
      //       }
      //     }
      //   }
      localStorage.setItem("Type", "Third");

      localStorage.setItem("score1", score1);
      localStorage.setItem("score2", score2);
      localStorage.setItem("score3", score3);
      //   localStorage.setItem("score4", score4);
      console.log("score1", score1, (score1 / 40) * 100);
      console.log("score2", score2, (score2 / 40) * 100);
      console.log("score3", score3, (score3 / 40) * 100);
      //   console.log("score4", score4, (score4 / 40) * 100);
    }
    // console.log(inputElement.current.innerText, "ref");
  };
  const previousHandler = () => {
    setShowError(false);
    if (count > 0) {
      setCount(count - 1);
    }
  };
  return (
    <div className="text-center ">
      <div className="flex flex-col justify-center items-start m-auto w-7/12 ">
        {/* {questions.map((ques) => {
          return ( */}
        <div id="custom-animation" className="w-full">
          {/* question */}

          <div className="text-start m-3 flex flex-row">
            {questions[count].question} &nbsp;
            {showError ? (
              <p className="text-red-500">'Select an option'</p>
            ) : (
              ""
            )}
            {/* {ques.question} */}
          </div>
          {/* top     ref={inputElement}*/}
          <div className="flex flex-row flex-wrap justify-center items-center m-auto  w-full">
            {questions[count].options.map((op) => {
              return (
                <div
                  key={op.id}
                  onClick={() => handleClick(op, questions[count])}
                  className={
                    op.isSelected
                      ? "bg-yellow-300 bg-opacity-30 block p-6 w-full md:w-3/12 m-3  rounded-lg border border-gray-200 shadow-md  cursor-pointer"
                      : "block p-6 w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md  cursor-pointer "
                  }
                >
                  <p className="font-normal text-gray-900 ">{op.op}</p>
                </div>
              );
            })}
            {/* <div
                  onClick={handleClick}
                  className="block p-6  w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md cursor-pointer"
                >
                  <p className="font-normal text-gray-900 ">Some what</p>
                </div>
                <div
                  onClick={handleClick}
                  className="block p-6 w-full md:w-3/12 m-3 bg-white rounded-lg border border-gray-200 shadow-md cursor-pointer"
                >
                  <p className="font-normal text-gray-900 ">No</p>
                </div> */}
          </div>
          <br />
        </div>
        {/* );
        })} */}

        {/* bottom */}
        <div className="flex flex-row w-full justify-between items-center m-auto ">
          {/* left-arrow */}
          <div
            onClick={previousHandler}
            className="w-3/12 md:w-1/12 p-2 m-2 bg-gray-300 rounded-full bg-opacity-20 cursor-pointer"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </div>
          {/* progress-bar */}
          <div className="w-6/12 md:w-9/12 bg-gray-300 bg-opacity-30 rounded-full h-1.5 mb-1 ">
            <div
              className="bg-purple h-1.5 rounded-full "
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          {/* right-arrow */}
          <div
            onClick={nextHandler}
            className="w-3/12 md:w-1/12 p-2 m-2 bg-gray-300 rounded-full bg-opacity-20 cursor-pointer"
          >
            <i className="fa-solid fa-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
